import { compact } from '@direct-frontend/stdlib';
import type { FiltersDeclaration, FilterSection, InferFilterItemFromFilter } from '@adv-frontend/filters';
import { type ProductFilterDeclaration } from '../hooks/useProductFiltersDeclaration';

/*
 * Функция, возвращающая динамические фильтры для меню, отфильтрованные от фильтров,
 * которые уже выбраны и могут быть выбраны один раз
 */
export function getMenuDynamicProductFilters<Filter extends ProductFilterDeclaration>(
    dynamicFilters: FiltersDeclaration<Filter>['dynamicFilters'],
    filterItems: InferFilterItemFromFilter<Filter>[]
): FiltersDeclaration<Filter>['dynamicFilters'] {
    return compact(
        (dynamicFilters ?? []).map((filter) => {
            if ('filters' in filter) {
                const newFilter: FilterSection<Filter> = {
                    ...filter,
                    filters: getMenuDynamicProductFilters(filter.filters, filterItems) ?? [],
                };

                return newFilter.filters.length === 0 ? null : newFilter;
            }

            const filterItem = filterItems.find((item) => item.filterId === filter.id);

            // если ни одного нет - показываем фильтр в списке
            if (!filterItem) {
                return filter;
            }

            // если уже есть один и это максимум - скрываем фильтр в списке (его нельзя будет добавить)
            if (filter.onlyOneFilterItem) {
                return null;
            }

            // если уже был добавлен фильтр с оператором равно, то мы не можем его использовать его с другими операторами - скрываем
            if (filterItem.operator === '=') {
                return null;
            }

            return filter;
        })
    );
}
